/* src/app/shared/components/address/address.component.css */
::ng-deep nz-switch .ant-switch:focus-visible {
  outline: none;
  transition: box-shadow 0.3s ease;
}
::ng-deep nz-switch .ant-switch.ant-switch-checked:focus-visible {
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.3);
  border-color: #40a9ff;
}
::ng-deep nz-switch .ant-switch:not(.ant-switch-checked):focus-visible {
  box-shadow: 0 0 0 3px rgba(150, 150, 150, 0.3);
  border-color: #d9d9d9;
}
::ng-deep .p-autocomplete {
  width: 100%;
}
/*# sourceMappingURL=address.component-PSWCLYGT.css.map */
